



import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CreateCoupon = () => {
  const [coupons, setCoupons] = useState([]);
  const [orders, setOrders] = useState([]);
  const [newCoupon, setNewCoupon] = useState({
    code: '',
    minCartAmount: '',
    discount: '',
    isActive: true,
  });

  const analyzeCouponUsage = (orders) => {
    const couponCounts = new Map();
  
    orders.forEach(order => {
      const coupon = order.couponcode;
    //   console.log("coupon:", coupon);
      if (coupon && coupon !== null) { 
        couponCounts.set(coupon, (couponCounts.get(coupon) || 0) + 1);
      }
    });
    console.log("count",Object.fromEntries(couponCounts))
    return Object.fromEntries(couponCounts); 
  };

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/api/myorders`, {
        headers: {
          token: token,
        },
      });
      setOrders(response.data);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    }
  };

  const fetchCoupons = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/api/fetchcoupon`, {
        headers: {
          token: localStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
      });
    //    console.log("cop",response.data)
      setCoupons(response.data);
    } catch (error) {
      console.error('Error fetching coupons:', error);
    }
  };

  useEffect(() => {
    fetchCoupons();
    fetchOrders();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCoupon({ ...newCoupon, [name]: value });
  };

  const validateCouponCode = (code) => {
    const couponCodeRegex = /^[a-zA-Z0-9]{6,}$/;
    return couponCodeRegex.test(code);
  };

  const addCoupon = async () => {
    if (!newCoupon.code || !newCoupon.minCartAmount || !newCoupon.discount) {
      alert('Please fill all fields');
      return;
    }

    if (!validateCouponCode(newCoupon.code)) {
      alert('Coupon code must be at least 6 characters long and alphanumeric.');
      return;
    }

    const couponCodeNormalized = newCoupon.code.toLowerCase();
    const isExistingCoupon = coupons.some(
      (coupon) => coupon.couponcode.toLowerCase() === couponCodeNormalized
    );

    if (isExistingCoupon) {
      alert('Coupon code already exists!');
      return;
    }

    try {
      const couponData = {
        CouponCode: newCoupon.code,
        min_cart_amt: parseFloat(newCoupon.minCartAmount),
        discount: parseFloat(newCoupon.discount),
        status: newCoupon.isActive ? 'active' : 'inactive',
      };

      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN_API_URL}/api/createcoupon`,
        couponData,
        {
          headers: {
            token: localStorage.getItem('token'),
            'Content-Type': 'application/json',
          },
        }
      );

      alert('Coupon added successfully!');
      setNewCoupon({ code: '', minCartAmount: '', discount: '', isActive: true });
      fetchCoupons();
    } catch (error) {
      console.error('Error adding coupon:', error);
      alert('Failed to add coupon.');
    }
  };

  const toggleActiveStatus = async (couponCode, status) => {
    try {
      const newStatus = status === 'active' ? 'inactive' : 'active';
      await axios.put(
        `${process.env.REACT_APP_ADMIN_API_URL}/api/updatecouponstatus/${couponCode}`,
        { status: newStatus },
        {
          headers: {
            token: localStorage.getItem('token'),
            'Content-Type': 'application/json',
          },
        }
      );
      fetchCoupons();
    } catch (error) {
      console.error('Error updating coupon status:', error);
      alert('Failed to update coupon status.');
    }
  };

  const deleteCoupon = async (couponCode) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_ADMIN_API_URL}/api/deletecoupon/${couponCode}`, {
        headers: {
          token: localStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        fetchCoupons();
        alert('Coupon deleted successfully');
      } else {
        alert('Failed to delete coupon.');
      }
    } catch (error) {
      console.error('Error deleting coupon:', error);
      alert('An error occurred while deleting the coupon.');
    }
  };

  // Calculate coupon usage
  const couponUsage = analyzeCouponUsage(orders);
  console.log("coude",couponUsage)

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Coupon Management</h1>

      <div className="bg-white p-4 rounded-md shadow-md mb-6">
        <h2 className="text-xl font-semibold mb-2">Create Coupon</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <input
            type="text"
            name="code"
            placeholder="Coupon Code"
            value={newCoupon.code}
            onChange={handleInputChange}
            className="p-2 border rounded-md"
          />
          <input
            type="number"
            name="minCartAmount"
            placeholder="Min Cart Amount"
            value={newCoupon.minCartAmount}
            onChange={handleInputChange}
            className="p-2 border rounded-md"
          />
          <input
            type="number"
            name="discount"
            placeholder="Discount %"
            value={newCoupon.discount}
            onChange={handleInputChange}
            className="p-2 border rounded-md"
          />
          <button
            onClick={addCoupon}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
          >
            Add Coupon
          </button>
        </div>
      </div>

      <div className="bg-white p-4 rounded-md shadow-md">
        <h2 className="text-xl font-semibold mb-2">Coupons List</h2>
        
        {coupons.length === 0 ? (
          <p className="text-gray-500">No coupons available</p>
        
        ) : (
          <table className="w-full table-auto mt-4 text-center">
            <thead>
              <tr>
                <th className="px-4 py-2">Coupon Code</th>
                <th className="px-4 py-2">Min Cart Amount</th>
                <th className="px-4 py-2">Discount %</th>
                <th className="px-4 py-2">Status</th>
                <th className="px-4 py-2">Times Used</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
                
              {coupons.map((coupon) => (
                
                <tr key={coupon._id} className="border-t text-center">
                  <td className="px-4 py-2">{coupon.couponcode}</td>
                  <td className="px-4 py-2">₹{coupon.min_cart_amt}</td>
                  <td className="px-4 py-2">{coupon.discount}%</td>
                  <td className="px-4 py-2">
                    {coupon.status === 'active' ? (
                      <span className="text-green-600">Active</span>
                    ) : (
                      <span className="text-red-600">Inactive</span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                        {couponUsage[coupon.couponcode] || 0}
                        
                        </td>
                        
                  <td className="px-6 py-4 flex items-center justify-center gap-4">
                    <button
                      onClick={() => toggleActiveStatus(coupon.couponcode, coupon.status)}
                      className={`px-3 py-1 rounded-md text-white ${
                        coupon.status === 'active'
                          ? 'bg-yellow-500 hover:bg-yellow-600'
                          : 'bg-green-500 hover:bg-green-600'
                      }`}
                    >
                      {coupon.status === 'active' ? 'Deactivate' : 'Activate'}
                    </button>
                    <button
                      onClick={() => deleteCoupon(coupon.couponcode)}
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-md"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CreateCoupon;